module.exports = __webpack_public_path__ + "1f28bf1681b770669d0b2b5a797bbeb3.svg";